<template lang="html"]>
 <div class="table_heading">
            <div class="row">                
                <div class="col-md-4 col-12">                                                         
                        <b-form-select v-model="selected" :options="category"></b-form-select>
                        ?>??{{selected}}---
                </div>
                <div class="col-md-4 col-12">

            


                    <!-- <select v-model="selectedYear">
                        <option value="2021">2021</option>    
                        <option value="2022">2022</option> 
                        
                    </select>
                    {{selectedYear}} -->
                </div>
                <div class="col-md-4 col-12">
                    <b-form-input id="keyword-search"  size="lg" placeholder="搜尋關鍵字"></b-form-input>
                </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['years', 'category'],
    data() {
        return {
            // selected:"2",
        }
    },   
    mounted() {
        this.initOptions();
        // moment.locale('zh-hk');
        // this.$nextTick(() => {
        //    // window.$(this.$refs.myTable).basictable();
        //    $('#table-breakpoint').basictable({
        //      breakpoint: 768,
        //       tableWrap: false,
        //        forceResponsive: true,
        //    });
        //  });
        
    },
    methods: {
        initOptions(){
            console.log("years %o, category %o", this.years, this.category[1]);            
            if(this.years){
                this.yearsOptions = this.years;                 
            }
            if(this.category){
                this.categoryOptions = this.category; 
            }
        },
        // goUrl(){
        //     console.log("on change");
        // }        
    }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/mlang/church/sermon/sermons.vue